module.exports = __webpack_public_path__ + "images/corporate_buybacks_lp/corporatebuybacks_lp_mainbanner_03531ceb88928fe86b4de135bd4fe27d.jpg";